<template>
    <div class="bg-white d-flex flex-column" style="max-height: 400px">
        <p class="font-weight-bold text-primary flex-shrink-0 px-3 py-3 mb-0 text-small"><v-icon color="primary" class="me-2" size="17">icon-bell</v-icon>اطلاع‌رسانی‌های 7 روز گذشته شما</p>
        <v-divider opacity="0.5"></v-divider>
        <div v-if="data.length" class="overflow-y-auto flex-grow-1">
            <div class="py-1 px-3 ga-3 border-b d-flex align-center cursor-pointer" v-for="item in data" @click="clicked(item)">
                <v-icon class="rounded-circle bg-grey-lighten-3 pa-1" size="20" color="primary">campaign</v-icon>
                <div>
                    <p class="text-small mb-1 text-grey-darken-2 font-weight-medium" >{{item.content}}</p>
                    <p class="text-small text-grey-darken-1">{{ $moment(item.date).fromNow() }}</p>
                </div>
            </div>
        </div>
        <div class="text-center pa-4" v-else>
            <img src="@/assets/img/empty-notification.svg" width="94.737" height="98.856">
            <p class="text-meta font-weight-medium text-grey mt-3">موردی برای نمایش وجود ندارد.</p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        data: {
            type: Array,
            default: [],
        },
    },
    methods: {
        clicked(item) {
            if(item.link.split(',')[0] == 'ticket') {
                this.$router.push({path: `/tickets/${item.link.split(',')[1]}`});
            }
            else if(item.link.split(',')[0] == 'custom')
                window.open(item.link.split(',')[1], '_blank');
        }
    },
};
</script>
